import Client from './Client'
import { Error } from './Error'

export default class Template extends Client {
  async fetchTemplatesByCategory(token) {
    try {
      return await this.request(token, 'get', 'category/template', null, null)
    } catch (error) {
      throw new Error(error)
    }
  }

  async fetchTemplate(token, id) {
    try {
      return await this.request(token, 'get', `template/${id}/cache`, null, null)
    } catch (error) {
      throw new Error(error)
    }
  }

  async fetchTemplateTitle(token, id) {
    try {
      return await this.request(token, 'get', `template/${id}/title`, null, null)
    } catch (error) {
      throw new Error(error)
    }
  }
}
